import sdl from '@jds/react-generated-sdl/JDSSegmentedRingItem';
import type { JDSSegmentedRingItemProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSSegmentedRingItemProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const { size = 'medium', custom = '', ...rest } = props as any;
  return createComponent(
    json,
    { size, ...rest },
    'JDSSegmentedRingItem',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const SegmentedRingItem = withLogic(
  Component
) as React.FC<JDSSegmentedRingItemProps> & { slotName?: string };

SegmentedRingItem.displayName = 'SegmentedRingItem';
SegmentedRingItem.slotName = 'jds_segmented_ring_item';

export { SegmentedRingItem, type JDSSegmentedRingItemProps };
